export default {
  fields: {
    receiverName: "Recipient Name:",
    phone: "Phone:",
    address: "Address:",
    quantity: "Quantity:",
    time: "Time:",
  },
  common: {
    empty: "No Data",
  },
};
